import { render, staticRenderFns } from "./sdVisitDetail.vue?vue&type=template&id=1fff530a&scoped=true"
import script from "./sdVisitDetail.vue?vue&type=script&lang=js"
export * from "./sdVisitDetail.vue?vue&type=script&lang=js"
import style0 from "./sdVisitDetail.vue?vue&type=style&index=0&id=1fff530a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fff530a",
  null
  
)

export default component.exports